import { FC, ReactNode } from "react";
import { Theme } from "apps/website/maps/Theme.map";

import Grid from "../../layout/Grid/Grid";
import Column from "../../layout/Column/Column";
import Image, { IImage } from "../../base/Image/Image";
import Section from "../../layout/Section/Section";
import { getSectionSize } from "../../layout/Section/Section.utils";
import Container from "../../layout/Container/Container";

type Direction = "default" | "reverse";

interface ISectionFreeImage extends IImage {
  justify?: "start" | "center" | "end";
}

export interface ISectionImageFreeFlowProps {
  image: ISectionFreeImage,
  children: ReactNode;
  theme?: Theme;
  direction?: Direction;
}

const SectionImageFreeFlow: FC<ISectionImageFreeFlowProps> = ({ image, children, theme = "default", direction = "default" }) => {
  const order = direction === "default" ? { image: "order-first", children: "order-last" } : { image: "order-last", children: "order-first" };

  return (<Section component={SectionImageFreeFlow.name} theme={theme} size={getSectionSize(theme)}>
    <Container>
      <Grid gap="lg">
        <Column spans={{ lg: 6 }} className={ `relative ${order.image}` } justify={image.justify ?? "start"}>
          <Image
            image={ image.image}
            alt={ image.image.alt || "" }
            data-testid="SectionImageFreeFlowImage"
          />
        </Column>
        <Column
          spans={ { lg: 6 } }
          justify="center"
          align={ "center" }
          data-testid="SectionImageFreeFlowChildren"
          className={ `relative ${order.children}` }
        >
          { children }
        </Column>
      </Grid>
    </Container>
  </Section >
  );
};

export default SectionImageFreeFlow;
